var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
import { createHashHistory, createBrowserHistory, createMemoryHistory } from "history";
import { NavigationRouterTypeEnum } from "../../types/router.js";
const _NavigationService = class _NavigationService {
  constructor(params) {
    __publicField(this, "_type");
    __publicField(this, "_history");
    const { type = NavigationRouterTypeEnum.Hash, initialEntries } = params || {};
    this._type = type;
    switch (type) {
      case NavigationRouterTypeEnum.Memory:
        this._history = createMemoryHistory({ initialEntries });
        break;
      case NavigationRouterTypeEnum.Browser:
        this._history = createBrowserHistory();
        break;
      case NavigationRouterTypeEnum.Hash:
      default:
        this._history = createHashHistory();
        break;
    }
  }
  get type() {
    return this._type;
  }
  get location() {
    if (this._type === NavigationRouterTypeEnum.Browser) {
      return window.location;
    }
    return this._history.location;
  }
  get action() {
    return this._history.action;
  }
  get history() {
    return this._history;
  }
  go(delta) {
    return this._history.go(delta);
  }
  back() {
    return this._history.back();
  }
  forward() {
    return this._history.forward();
  }
  createHref(to) {
    return this._history.createHref(to);
  }
  push(to, state) {
    return this._history.push(to, state);
  }
  replace(to, state) {
    return this._history.replace(to, state);
  }
  block(blocker) {
    return this._history.block(blocker);
  }
  listen(listener) {
    return this._history.listen(listener);
  }
  static getInstance(params) {
    if (!_NavigationService.instance) {
      _NavigationService.instance = new _NavigationService(params || {});
    }
    return _NavigationService.instance;
  }
};
__publicField(_NavigationService, "instance");
let NavigationService = _NavigationService;
export {
  NavigationService
};
